export default {
  data() {
    return {
      coachAss: 1,
      coachAssFilter: 'recent',
      coachMemberKey: 1,
      coachMemberSort: 'name-d',
      coachMemberAssKey: 1,
      coachMemberAssSort: 'assignmentName-d',
      selectedGroup: null,
      loading: true,
      feedbackLoaded: false,
      newGroup: '',
      showRecordingLinksForGroup: {},
      creatingNewGroup: false,
      coachDashboardToggle: null,
      templateToggle: null,
      filters: {},
    };
  },
  computed: {
    sharingCellColspan() {
      if (this.selectedGroup.speakerPrivacyLevel !== 4) {
        return this.recordingsTableHeadings.length - 3;
      }
      return this.recordingsTableHeadings.length - 2;
    },
    recordingsTableHeadings: {
      cache: true,
      get() {
        const showRatings = !!(this.selectedGroup.speakerPrivacyLevel !== 4);
        let recordingsTableHeadings = [
          { width: '20%', text: 'Recording Name' },
          { width: '20%', text: 'History' },
          { width: '20%', text: 'Total Length' },
          { width: '20%', text: 'Vocal Delivery' },
          { width: '20%', text: 'Comments' },
        ];

        if (showRatings) {
          recordingsTableHeadings.push({ width: '20%', text: 'Overall Rating' });
        }
        recordingsTableHeadings.push({ width: '20%', text: 'Coach Overall Rating' });
        return recordingsTableHeadings;
      }
    },
    speakers: {
      cache: true,
      get() {
        const members = [];
        this._.forEach(this.augmentedMembers[this.selectedGroup.groupId], (member) => {
          // TODO: Maybe move the filtering here?
          // const filterFunc = filterFuncs[this.assPreviewFilter] || filterFuncs['all'];
          if (member.membershipStatus === 'active') {
            // Suppress inactive members
            members.push(member);
          }
        });

        return this.sortCollection(members, this.coachMemberSort);
      }
    },
    // This is referenced by AssignmentDataStructures mixin
    assignments: {
      cache: true,
      get() {
        return this.$store.getters.assignments;
      }
    },
    filteredTemplates() {
      const filterFuncs = {
        shared: (t) => {
          return !!t.orgId;
        },
        all: () => {
          return true;
        },
        private: (t) => {
          return !t.orgId && t.orgId !== 0;
        }
      };
      return this.templates.filter(filterFuncs[this.templateToggle]);
    },
    templates() {
      return _.filter(this.augmentedAssignments, (a) => {
        if (!a.isTemplate) return false;
        if (!a.isGlobal) return true;

        if (a.criteria.algorithm &&a.criteria.algorithm.indexOf('default') !== -1) {
          return this.availableAlgorithms.default;
        }
        if (a.criteria.algorithm &&a.criteria.algorithm.indexOf('conversational') !== -1) {
          return this.availableAlgorithms.conversational;
        }
      });
    },
    groupAssignments() {
      return this._.filter(
        this.augmentedAssignments,
        (a) => !a.isTemplate && a.groupId  == this.selectedGroup.groupId
      );
    },
    sortableGroupAssignments() {
      const assignments = [];
      let i = 1;
      this.sortAssignments(this.groupAssignments).forEach((ass) => {
        const filterFunc = (a) => {
          return (
            (a.archived !== true) &&
            !(a.assignmentAssignedCount == a.assignmentCompletedCount &&
              (!a.groupTargets || !a.groupTargets.length))
          );
        };
        if (filterFunc(ass)) {
          const _ass = _.cloneDeep(ass);
          _ass.derivedSortOrder = i++;
          assignments.push(_ass);
        }
      });
      return assignments;
    },
    filteredGroupAssignments() {
      /* Filter the Assignment Cards */
      const filterFuncs = {
        recent: (a) => {
          const assDate = new Date(a.createdDate).getTime() / 1000;
          let backWhen = new Date().getTime() / 1000;
          backWhen = backWhen - (28 * (60 * 60 * 24));
          const isRecentlyCompleted = (a.assignmentCompletedCount == a.assignmentAssignedCount && assDate > backWhen);
          const isCompletedContinuous = (a.assignmentCompletedCount == a.assignmentAssignedCount && a.groupTargets && a.groupTargets.length);
          return a.archived !== true &&
            (a.assignmentCompletedCount != a.assignmentAssignedCount || isRecentlyCompleted || isCompletedContinuous);
        },
        active: (a) => {
          return (a.archived !== true &&
            (a.assignmentCompletedCount != a.assignmentAssignedCount ||
            (a.groupTargets && a.groupTargets.length)));
        },
        all: () => {
          return true;
        },
        completed: (a) => {
          return a.archived !== true && a.assignmentCompletedCount == a.assignmentAssignedCount;
        },
      };
      const assignments = [];
      this.groupAssignments.forEach((ass) => {
        const filterFunc = filterFuncs[this.coachAssFilter] || filterFuncs['all'];
        if (filterFunc(ass)) {
          assignments.push(ass);
        }
      });
      const sortedAssignments = this.sortAssignments(assignments);
      return sortedAssignments;
    },
    myClassesCaption: {
      cache: true,
      get() {
        if (this.loading || !this.selectedGroup) {
          return 'Loading...';
        }
        if (this.selectedGroup.roles.indexOf('manager') === -1) {
          return 'Click names below to view recordings your peers have shared with you';
        }

        const student = (this.isEdu) ? 'student' : 'speaker';
        const _class = (this.isEdu) ? 'class' : 'group';
        const classFirstUpper = (this.isEdu) ? 'Class' : 'Group';
        if (this.selectedGroup.managerPrivacyLevel === 0) {
          return `Sharing is disabled for this ${_class}`;
        }
        if (this.selectedGroup.managerPrivacyLevel === 1) {
          return `${classFirstUpper} List - click a ${student}\'s name to view their recordings`;
        }
        if (this.selectedGroup.managerPrivacyLevel === 2) {
          return 'Click names below to view any recordings that have been shared with you';
        }
        if (this.selectedGroup.managerPrivacyLevel >= 3) {
          return `${classFirstUpper} List - note the count reflects only the number of recordings the ${student} shared with you.`;
        }

        // Nothing should ever use this value
        return 'Click names below to view any recordings that have been shared with you';
      }
    },
    emptyGroup: {
      cache: true,
      get() {
        if (this.loading || !this.selectedGroup) {
          return 'Loading...';
        }
        const students = (this.isEdu) ? 'students' : 'speakers';
        const _class = (this.isEdu) ? 'class' : 'group';

        // If they're not a manager in the group and sharing is disabled, show a special msg
        if (this.selectedGroup.roles.indexOf('manager') === -1 &&
          this.selectedGroup.speakerPrivacyLevel === 0 ||
          this.selectedGroup.speakerPrivacyLevel >= 4) {
          return `Peer sharing is not enabled on this ${_class}.`;
        }

        return `There are currently no ${students} in this ${_class}.`;
      }
    },
    showDownloadReport() {
      const org = this.$store.getters.org;
      const downloadReportEnabled = (org && typeof org.settings !== 'undefined' && org.settings.Download_Report_Button);
      const isGroupManager = (this.selectedGroup && this.selectedGroup.roles && this.selectedGroup.roles.indexOf('manager') !== -1);

      return (isGroupManager && downloadReportEnabled);
    },
    currentUserId() {
      return this.$store.getters.user.userId;
    },
    showWordspotting() {
      const org = this.$store.getters.org;
      const groups = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Groups);
      const orgs = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Orgs);

      return ((groups && this.isGroupManager) || (orgs && this.isOrgLevelAdmin));
    },
    statActiveAssignments() {
      return _.filter(this.groupAssignments, a => {
        // Do not count assignments which are archived or deleted
        if (a.archived || a.deleted) {
          return false;
        }
        // If not a continuous assignment (groupTargets empty), check that not already completed by everyone it's been assigned to
        if (!a.groupTargets || a.groupTargets.length == 0) {
          if (a.members && a.members.length > 0) {
            if (_.every(a.members, u => u.completionStatus.status == 'completed')) {
              return false;
            }
          }
        }
        return true;
      }).length;
    },
    statTotalRecordings() {
      return _.filter(this.groupAssignments, a => !a.archived && !a.deleted)
        .reduce((previous, a) => previous + a.recordings.length, 0);
    },
    statTotalComments() {
      // for each non-deleted, non-archived assignment, iterate over recordings and accumulate number of comments for each.
      let totalComments = 0;
      _.filter(this.groupAssignments, a => !a.archived && !a.deleted)
        .forEach((rec) => totalComments += rec.feedbackCount);
      return totalComments;
    },
    statRecordingsSubmitted() {
      // foreach non-deleted assignment, count recordings with submitted flag
      return this.groupAssignments.filter( a => !a.archived && !a.deleted )
        .reduce((previousA, a) => previousA + a.recordings.filter(r => Boolean(r.submitted)).length, 0);
    },
    stats() {
      return [
        { name: 'Active Assignments', value: this.statActiveAssignments },
        { name: 'Total Recordings', value: this.statTotalRecordings },
        { name: 'Total Comments', value: this.statTotalComments },
        { name: 'Recordings For Review', value: this.statRecordingsSubmitted }
      ];
    }
  },
  watch: {
    selectedGroup() {
      // Update the preferences store with the newly selected group
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {selectedGroup: this.selectedGroup})
      );
    }
  },
  methods: {
    basePageCreated() {
      this.loadAllAssignmentsData(true).then(() => {
        if (!this.assignmentsEnabled) {
          return this.$router.push({ name: 'manage' });
        }
        this.loadCurrentModeFromPreferences();

        this.prepTableRowIndices();
        ['coachAssFilter', 'filters', 'coachMemberSort', 'coachMemberAssSort'].forEach((pref) => {
          if (this.preferences && this.preferences[pref]) {
            this[pref] = this.preferences[pref];
          }
        });

        if (this.preferences && this.preferences.selectedGroup) {
          const _groupId = (this.preferences.selectedGroup.groupId) ?
            this.preferences.selectedGroup.groupId : this.preferences.selectedGroup;

          // We cannot directly assign preferences to selectedGroup or the selectbox will be empty
          const selectedGroup = this._.find(this.managedGroups, (g) => g.groupId === _groupId);
          this.selectedGroup = (selectedGroup) ? selectedGroup : this.managedGroups[0];
        } else {
          this.selectedGroup = this.managedGroups[0];
        }

        if (this.preferences && this.preferences.coachDashboardToggle) {
          this.coachDashboardToggle = this.preferences.coachDashboardToggle;
        } else {
          this.coachDashboardToggle = 'assignments';
        }
        if (this.preferences && this.preferences.templateToggle) {
          this.templateToggle = this.preferences.templateToggle;
        } else {
          this.templateToggle = 'all';
        }
        this.loading = false;
      });
    },
    addGroup() {
      // Puts newly added group into list and selects it
      const showNewGroup = () => {
        this.$store.dispatch('listGroups').then((groups) => {
          this.selectedGroup = this._.find(groups, (obj) => obj.name == this.newGroup);
          this.newGroup = '';
          this.loading = false;
          this.$forceUpdate();
        });
      };

      if (this.newGroup === '') {
        document.getElementById('newGroup').focus();
      } else {
        this.creatingNewGroup = false; // Hides the new group inputs
        this.loading = true;
        this.$store.dispatch('addGroup', {
          name: this.newGroup,
          orgName: this.$store.getters.org.name
        })
          .then(() => window.setTimeout(showNewGroup, 1000))
          .catch(() => {
            this.loading = false;
            alert('The ' + ((this.isEdu) ? 'class' : 'group') + ' could not be saved. Most likely, the name you entered is already used elsewhere.\n' +
              'Please change the name to be unique.');
            this.creatingNewGroup = true;
          });
      }
    },
    setGroupFilter(groupId, type, filterVal) {
      if (this.filters[groupId] === undefined) {
        this.filters[groupId] = {};
      }
      this.filters[groupId][type] = filterVal;

      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {filters: this.filters})
      );

      this.coachMemberKey += 1; // Force re-render of table
    },
    getSpeakerClass(speaker) {
      let _class = '';
      if (speaker.assignments && speaker.assignments.length) {
        const filterAss = this.filterAssignments(_.cloneDeep(speaker.assignments));
        if (filterAss && filterAss.length) {
          filterAss.forEach((ass) => {
            if (ass.recordings && ass.recordings.length) {
              ass.recordings.forEach((rec) => {
                if (rec.submitted) {
                  _class = 'submitted';
                }
              });
            }
          });
        }
      }
      return _class;
    },
    getRecordingClass(recording) {
      return recording.submitted ? 'submitted' : '';
    },
    getAssignmentClass(ass) {
      let _class = '';
      if (ass.recordings && ass.recordings.length) {
        ass.recordings.forEach((rec) => {
          if (rec.submitted) {
            _class = 'submitted';
          }
        });
      }
      return _class;
    },
    getGroupFilter(groupId, type) {
      const defaults = { assignments: 'recent', recordings: 'all' };
      // filter not yet defined for this group
      if (this.filters[groupId] === undefined) {
        this.filters[groupId] = _.clone(defaults);
      }
      return this.filters[groupId][type];
    },
    filterAssignments(assignments) {
      /* Filter the Members' Assignments */
      const filterFuncs = {
        completed: (a) => {
          return a.completionStatus.status == 'completed';
        },
        active: (a) => {
          return a.completionStatus.status != 'completed';
        },
        all: () => {
          return true;
        },
        recent: (a) => {
          const assDate = new Date(a.createdDate).getTime() / 1000;
          let backWhen = new Date().getTime() / 1000;
          backWhen = backWhen - (28 * (60 * 60 * 24));
          const isRecentlyCompleted = (a.completionStatus.status == 'completed' && assDate > backWhen);
          return a.archived !== true &&
            (a.completionStatus.status != 'completed' || isRecentlyCompleted);
        }
      };

      const assignmentsFilter = this.getGroupFilter(this.selectedGroup.groupId, 'assignments');
      const filterFunction = filterFuncs[assignmentsFilter] || filterFuncs.all;
      return this.sortCollection(assignments.filter(filterFunction), this.coachMemberAssSort);
    },
    filterRecordings(recordings) {
      const filterFuncs = {
        flagged: (r) => {
          return r.submitted;
        },
        shared: (r) => {
          return r.feedbackRequested;
        },
        all: () => {
          return true;
        },
        withComments: (r) => {
          return r.numComments > 0;
        }
      };

      const recordingsFilter = this.getGroupFilter(this.selectedGroup.groupId, 'recordings');
      const filterFunction = filterFuncs[recordingsFilter];
      return recordings.filter(filterFunction);
    },
    toggle(mode) {
      this.coachDashboardToggle = mode;
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {coachDashboardToggle: this.coachDashboardToggle})
      );
    },
    toggleTemplate(mode) {
      this.templateToggle = mode;
      this.$store.dispatch(
        'updatePreferences',
        Object.assign(this.preferences, {templateToggle: this.templateToggle})
      );
    }
  }
};
